import React, { Component } from 'react';

import Modal from 'components/Modal';

import { CloseButton } from './styles';

export class ErrorMessageModal extends Component {
	render() {
		const { message = '', onClose } = this.props;

		return (
			<Modal title="Validation errors" onClose={onClose}>
				<CloseButton onClick={onClose} />
				<div>{message}</div>
			</Modal>
		);
	}
}
